enum BillingPeriod {
  Month = "MONTH",
  HalfMonth = "HALFMONTH",
  Immediately = "IMMEDIATELY",
  Week = "WEEK",
}
export default BillingPeriod;
